<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
  <div class="container-header-inner-list">
    <div class="row mb-4">
      <div class="col-md-6">
        <div class="title-wrapper">
          <div>
            <h1 class="title-default">Contas a Receber</h1>
            <p class="welcome-message">Gerenciamento de recebimentos e Clientes</p>
          </div>
        </div>
      </div>
      <div class="col-md-6 header-actions">
        <button mat-stroked-button class="btn-secondary" [matMenuTriggerFor]="opcoesMenu">
          @if (selection.hasValue()) {
          <span>Ações ({{ selection.selected.length }})</span>
          } @else {
          <span>Ações</span>
          }
          <mat-icon iconPositionEnd>arrow_drop_down</mat-icon>
        </button>

        <mat-menu #opcoesMenu="matMenu">
          @if (selection.hasValue()) {
          <button mat-menu-item (click)="abrirRecebimento(selection.selected)" [disabled]="!isAllSelectedRecebivel()"
            [matTooltip]="tooltipBulkReceber()" [matTooltipDisabled]="isAllSelectedRecebivel()">
            <mat-icon class="material-symbols-outlined">payments</mat-icon>
            <span>Receber</span>
          </button>
          <span class="menu-item-tooltip-wrapper" [matTooltip]="tooltipBulkEditarPeloFinancas()" [matTooltipDisabled]="isAllSelectedEditavelPeloFinancas()">
            <button mat-menu-item (click)="alterarFormaRecebimento()" [disabled]="!isAllSelectedEditavelPeloFinancas()">
              <mat-icon class="material-symbols-outlined">swap_horiz</mat-icon>
              <span>Alterar forma de recebimento</span>
            </button>
          </span>
          <button mat-menu-item (click)="alterarTagsEmMassa()">
            <mat-icon class="material-symbols-outlined">label</mat-icon>
            <span>Alterar tags</span>
          </button>
          <button mat-menu-item (click)="alterarCategoriaEmMassa()" [disabled]="!isAllSelectedEditavel()"
            [matTooltip]="tooltipBulkEditar()" [matTooltipDisabled]="isAllSelectedEditavel()">
            <mat-icon class="material-symbols-outlined">category</mat-icon>
            <span>Alterar categoria</span>
          </button>
          <span class="menu-item-tooltip-wrapper" [matTooltip]="tooltipBulkEditarPeloFinancas()" [matTooltipDisabled]="isAllSelectedEditavelPeloFinancas()">
            <button mat-menu-item (click)="editarEmMassa()" [disabled]="!isAllSelectedEditavelPeloFinancas()">
              <mat-icon class="material-symbols-outlined">edit_note</mat-icon>
              <span>Edição em Massa</span>
            </button>
          </span>
          <button mat-menu-item (click)="agruparContas()" [disabled]="!isAllSelectedAgrupavel()"
            [matTooltip]="tooltipBulkAgrupar()" [matTooltipDisabled]="isAllSelectedAgrupavel()">
            <mat-icon class="material-symbols-outlined">merge</mat-icon>
            <span>Agrupar contas / Renegociar</span>
          </button>
          <span class="menu-item-tooltip-wrapper" [matTooltip]="tooltipBulkCancelar()" [matTooltipDisabled]="isAllSelectedCancelavel()">
            <button mat-menu-item (click)="cancelarContas()" [disabled]="!isAllSelectedCancelavel()">
              <mat-icon class="material-symbols-outlined">cancel</mat-icon>
              <span>Cancelar contas</span>
            </button>
          </span>
          <button mat-menu-item (click)="baixarBoletos()" [disabled]="!isAllSelectedBoletoBaixavel()"
            [matTooltip]="'Selecione ao menos um boleto registrado para baixar'"
            [matTooltipDisabled]="isAllSelectedBoletoBaixavel()">
            <mat-icon class="material-symbols-outlined">receipt_long</mat-icon>
            <span>Baixar boletos</span>
          </button>
          <span class="menu-item-tooltip-wrapper" [matTooltip]="tooltipBulkExcluir()" [matTooltipDisabled]="isAllSelectedExcluivel()">
            <button mat-menu-item (click)="excluirContas()" [disabled]="!isAllSelectedExcluivel()">
              <mat-icon class="material-symbols-outlined">delete</mat-icon>
              <span>Excluir selecionados</span>
            </button>
          </span>
          } @else {
          <button mat-menu-item (click)="abrirImpressao()">
            <mat-icon class="material-symbols-outlined">print</mat-icon>
            <span>Imprimir</span>
          </button>
          <button mat-menu-item (click)="exportarContasReceber()">
            <mat-icon class="material-symbols-outlined">file_upload</mat-icon>
            <span>Exportar lançamentos para planilha</span>
          </button>
          <button mat-menu-item (click)="abrirImportacao()">
            <mat-icon class="material-symbols-outlined">file_download</mat-icon>
            <span>Importar lançamentos de uma planilha</span>
          </button>
          }
        </mat-menu>

        <button type="button" mat-flat-button class="btn-primary" routerLink="/financas/contas-receber/cadastrar">
          <span class="material-symbols-outlined">add</span>
          Nova Conta a Receber
        </button>
      </div>
    </div>

    <form [formGroup]="model" (ngSubmit)="clickPesquisar()">
      <div class="row search-area">
        <div class="col-12 col-md-4">
          <mat-form-field appearance="outline">
            <mat-label>Pesquisar</mat-label>
            <input matInput type="text" formControlName="pesquisa" placeholder="Pesquise por Cliente ou nº documento" />

            <button mat-icon-button matSuffix [matMenuTriggerFor]="refinarMenu" type="button" aria-label="Refinar Busca"
              matTooltip="Refinar busca">
              <mat-icon>tune</mat-icon>
            </button>
            <mat-menu #refinarMenu="matMenu">
              <button mat-menu-item (click)="filtroRefinar = null">
                @if (filtroRefinar === null) {
                <mat-icon>check</mat-icon>
                }
                <span [class.ps-4]="filtroRefinar !== null">Não refinar</span>
              </button>
              <button mat-menu-item (click)="filtroRefinar = _refinamentoEnum.Cliente">
                @if (filtroRefinar === _refinamentoEnum.Cliente) {
                <mat-icon>check</mat-icon>
                }
                <span [class.ps-4]="filtroRefinar !== _refinamentoEnum.Cliente">Cliente</span>
              </button>
              <button mat-menu-item (click)="filtroRefinar = _refinamentoEnum.NumeroDocumento">
                @if (filtroRefinar === _refinamentoEnum.NumeroDocumento) {
                <mat-icon>check</mat-icon>
                }
                <span [class.ps-4]="filtroRefinar !== _refinamentoEnum.NumeroDocumento">Nº documento</span>
              </button>
              <button mat-menu-item (click)="filtroRefinar = _refinamentoEnum.Historico">
                @if (filtroRefinar === _refinamentoEnum.Historico) {
                <mat-icon>check</mat-icon>
                }
                <span [class.ps-4]="filtroRefinar !== _refinamentoEnum.Historico">Histórico</span>
              </button>
            </mat-menu>

            <button mat-icon-button matSuffix type="submit" aria-label="Pesquisar">
              <mat-icon>search</mat-icon>
            </button>
          </mat-form-field>
        </div>

        <div class="col-12 col-md-8 mb-3 mb-md-0 d-flex flex-wrap gap-3">
          <!-- Seletor de Periodo -->
          <button #periodoMenuTrigger="matMenuTrigger" mat-stroked-button type="button" class="btn-periodo"
            [matMenuTriggerFor]="periodoMenu" (menuOpened)="prepararPeriodoIntervalo()" [class.btn-periodo--ativo]="
              periodoSelecionado !== PeriodoContasReceberEnum.Ultimos30Dias &&
              periodoSelecionado !== undefined
            ">
            {{ periodoLabel }}
            <mat-icon iconPositionEnd>arrow_drop_down</mat-icon>
          </button>
          <mat-menu #periodoMenu="matMenu" class="periodo-custom-menu" (closed)="onPeriodoMenuClosed()">
            <div class="periodo-menu-content">
              <div>
                <button type="button" class="periodo-menu-item"
                  (click)="selecionarPeriodo(PeriodoContasReceberEnum.Hoje); aplicarPeriodo()"
                  [class.periodo-item-selecionado]="periodoSelecionado === PeriodoContasReceberEnum.Hoje">
                  <span>hoje</span>
                  @if (periodoSelecionado === PeriodoContasReceberEnum.Hoje) {
                  <mat-icon>check</mat-icon>
                  }
                </button>
                <button type="button" class="periodo-menu-item"
                  (click)="selecionarPeriodo(PeriodoContasReceberEnum.DaSemana); aplicarPeriodo()"
                  [class.periodo-item-selecionado]="periodoSelecionado === PeriodoContasReceberEnum.DaSemana">
                  <span>desta semana</span>
                  @if (periodoSelecionado === PeriodoContasReceberEnum.DaSemana) {
                  <mat-icon>check</mat-icon>
                  }
                </button>
                <button type="button" class="periodo-menu-item"
                  (click)="selecionarPeriodo(PeriodoContasReceberEnum.DoMes); aplicarPeriodo()"
                  [class.periodo-item-selecionado]="periodoSelecionado === PeriodoContasReceberEnum.DoMes">
                  <span>do mês</span>
                  @if (periodoSelecionado === PeriodoContasReceberEnum.DoMes) {
                  <mat-icon>check</mat-icon>
                  }
                </button>
                <button type="button" class="periodo-menu-item"
                  (click)="selecionarPeriodo(PeriodoContasReceberEnum.Ultimos30Dias); aplicarPeriodo()"
                  [class.periodo-item-selecionado]="
                    periodoSelecionado === PeriodoContasReceberEnum.Ultimos30Dias
                  ">
                  <span>últimos 30 dias</span>
                  @if (periodoSelecionado === PeriodoContasReceberEnum.Ultimos30Dias) {
                  <mat-icon>check</mat-icon>
                  }
                </button>
                <button type="button" class="periodo-menu-item"
                  (click)="selecionarPeriodo(PeriodoContasReceberEnum.DoIntervalo); $event.stopPropagation()"
                  [class.periodo-item-selecionado]="
                    periodoSelecionado === PeriodoContasReceberEnum.DoIntervalo
                  ">
                  <span>do intervalo</span>
                  @if (periodoSelecionado === PeriodoContasReceberEnum.DoIntervalo) {
                  <mat-icon>check</mat-icon>
                  }
                </button>

                @if (periodoSelecionado === PeriodoContasReceberEnum.DoIntervalo) {
                <div class="periodo-intervalo-fields" (click)="$event.stopPropagation()">
                  <mat-form-field appearance="outline">
                    <mat-label>De</mat-label>
                    <input matInput [matDatepicker]="pickerPeriodoDe" placeholder="DD/MM/AAAA"
                      (input)="onDateInput($event, 'dataDe')" formControlName="dataDe" />
                    <mat-datepicker-toggle matSuffix [for]="pickerPeriodoDe"></mat-datepicker-toggle>
                    <mat-datepicker #pickerPeriodoDe></mat-datepicker>
                    @if (model.get('dataDe')?.hasError('required')) {
                    <mat-error>Data inicial obrigatória</mat-error>
                    }
                  </mat-form-field>
                  <mat-form-field appearance="outline">
                    <mat-label>Até</mat-label>
                    <input matInput [matDatepicker]="pickerPeriodoAte" placeholder="DD/MM/AAAA"
                      (input)="onDateInput($event, 'dataAte')" formControlName="dataAte" />
                    <mat-datepicker-toggle matSuffix [for]="pickerPeriodoAte"></mat-datepicker-toggle>
                    <mat-datepicker #pickerPeriodoAte></mat-datepicker>
                    @if (model.get('dataAte')?.hasError('required')) {
                    <mat-error>Data final obrigatória</mat-error>
                    }
                    @if (model.get('dataAte')?.hasError('dataInvalida')) {
                    <mat-error>Data final menor que inicial</mat-error>
                    }
                    @if (model.get('dataAte')?.hasError('intervaloExcedido')) {
                    <mat-error>Intervalo máx. de {{ limiteMeses }} meses</mat-error>
                    }
                  </mat-form-field>

                  <div class="periodo-intervalo-actions">
                    <button type="button" mat-button class="btn-secondary"
                      (click)="cancelarPeriodoIntervalo(periodoMenuTrigger)">
                      Cancelar
                    </button>
                    <button type="button" mat-flat-button class="btn-primary"
                      (click)="aplicarPeriodo(periodoMenuTrigger)">
                      Aplicar
                    </button>
                  </div>
                </div>
                }
              </div>
            </div>
          </mat-menu>

          <button mat-stroked-button type="button" class="btn-filter" [matMenuTriggerFor]="filtroMenu"
            [matBadge]="qtdFiltrosAvancados" [matBadgeHidden]="qtdFiltrosAvancados === 0">
            <mat-icon>filter_list</mat-icon>
            Filtrar
          </button>
          <mat-menu #filtroMenu="matMenu" class="filter-custom-menu">
            <div class="filter-menu-content" [formGroup]="model">
              <div (click)="$event.stopPropagation()">
                <h6>Filtros Avançados</h6>

                <div class="filter-menu__form">
                  <!-- Situação -->
                  <app-select-pesquisavel label="Situação do Recebimento" [control]="$any(model.get('idStatus'))"
                    [idField]="'idStatusContasReceber'" [nameField]="'descricao'" [offlineList]="listaSituacaoFiltro"
                    [isOptional]="true" hint="Todas">
                  </app-select-pesquisavel>

                  <!-- Categoria -->
                  <app-select-pesquisavel label="Categoria" [control]="$any(model.get('idCategoria'))"
                    [idField]="'idCategoriaFinanceira'" [nameField]="'descricao'" [offlineList]="listaCategoria"
                    [isOptional]="true" hint="Selecionar Categoria">
                  </app-select-pesquisavel>

                  <!-- Forma de Recebimento -->
                  <app-select-pesquisavel label="Forma de Recebimento" [control]="$any(model.get('idFormaRecebimento'))"
                    [idField]="'idFormaRecebimento'" [nameField]="'descricao'" [offlineList]="listaFormaRecebimento"
                    [isOptional]="true" hint="Todas">
                  </app-select-pesquisavel>

                  <!-- Tags -->
                  <app-select-pesquisavel label="Tags" [control]="$any(model.get('tags'))"
                    [idField]="'idTagContasReceber'" [nameField]="'descricao'" [offlineList]="listaTags"
                    [multiple]="true" [isOptional]="true" hint="Selecione tags">
                  </app-select-pesquisavel>
                </div>
              </div>

              <div class="filter-menu__actions">
                <button mat-button class="btn-secondary" matMenuClose>Cancelar</button>
                <button mat-flat-button class="btn-primary" (click)="aplicarFiltros()" matMenuClose>
                  Aplicar
                </button>
              </div>
            </div>
          </mat-menu>

          <button mat-stroked-button type="button" class="btn-filter" (click)="limparFiltros()">
            <mat-icon>cleaning_services</mat-icon>
            Limpar Filtros
          </button>

          <button mat-stroked-button type="button" class="btn-filter desktop-view" (click)="configurarColunas()">
            <mat-icon>view_column</mat-icon>
            Configurar Colunas
          </button>
        </div>
      </div>
    </form>

    @if (_response && _dataSource.data.length > 0) {
    <div class="table-container desktop-view">
      <table mat-table [dataSource]="_dataSource">
        <!-- Checkbox -->
        <ng-container matColumnDef="select">
          <th mat-header-cell *matHeaderCellDef class="w-checkbox">
            <mat-checkbox (change)="$event ? toggleAllRows() : null" [checked]="selection.hasValue() && isAllSelected()"
              [aria-label]="checkboxLabel()">
            </mat-checkbox>
          </th>
          <td mat-cell *matCellDef="let row" class="w-checkbox">
            <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(row) : null"
              [checked]="selection.isSelected(row)" [aria-label]="checkboxLabel(row)">
            </mat-checkbox>
          </td>
        </ng-container>

        <!-- Cliente -->
        <ng-container matColumnDef="cliente">
          <th mat-header-cell *matHeaderCellDef>Cliente</th>
          <td mat-cell *matCellDef="let row">{{ row.cliente || '-' }}</td>
        </ng-container>

        <!-- Descrição -->
        <ng-container matColumnDef="descricao">
          <th mat-header-cell *matHeaderCellDef>Descrição</th>
          <td mat-cell *matCellDef="let row">
            <div class="descricao-cell" [matTooltip]="
                row.isParcelado
                  ? 'Parcela ' + (row.nroParcela || 1) + ' de ' + (row.qtdParcelas || row.nroParcela || 1)
                  : row.isRecorrente
                    ? 'Recorrente'
                    : ''
              " [matTooltipDisabled]="!row.isParcelado && !row.isRecorrente">
              @if (row.isRecorrente) {
              <mat-icon class="tipo-lancamento-icon">autorenew</mat-icon>
              } @else if (row.isParcelado) {
              <mat-icon class="tipo-lancamento-icon">content_copy</mat-icon>
              }
              <span class="text-truncate">{{ row.descricao || '-' }}</span>
            </div>
          </td>
        </ng-container>

        <!-- Nº Documento -->
        <ng-container matColumnDef="numeroDocumento">
          <th mat-header-cell *matHeaderCellDef>Nº documento</th>
          <td mat-cell *matCellDef="let row">{{ row.numeroDocumento || '-' }}</td>
        </ng-container>

        <!-- Categoria -->
        <ng-container matColumnDef="categoria">
          <th mat-header-cell *matHeaderCellDef>Categoria</th>
          <td mat-cell *matCellDef="let row">{{ row.categoria || '-' }}</td>
        </ng-container>

        <!-- Forma de Recebimento -->
        <ng-container matColumnDef="formaRecebimento">
          <th mat-header-cell *matHeaderCellDef>Forma de Recebimento</th>
          <td mat-cell *matCellDef="let row">{{ row.formaRecebimento || '-' }}</td>
        </ng-container>

        <!-- Emissão -->
        <ng-container matColumnDef="dataEmissao">
          <th mat-header-cell *matHeaderCellDef>Emissão</th>
          <td mat-cell *matCellDef="let row">{{ row.dataEmissao ? (row.dataEmissao | date: 'dd/MM/yyyy') : '-' }}</td>
        </ng-container>

        <!-- Valor -->
        <ng-container matColumnDef="valor">
          <th mat-header-cell *matHeaderCellDef>Valor</th>
          <td mat-cell *matCellDef="let row">{{ row.valor | abnt: 'preco': 2 }}</td>
        </ng-container>

        <!-- Recebido -->
        <ng-container matColumnDef="recebido">
          <th mat-header-cell *matHeaderCellDef>Recebido</th>
          <td mat-cell *matCellDef="let row">{{ row.recebido | abnt: 'preco': 2 }}</td>
        </ng-container>

        <!-- A Receber -->
        <ng-container matColumnDef="aReceber">
          <th mat-header-cell *matHeaderCellDef>A Receber</th>
          <td mat-cell *matCellDef="let row">{{ row.aReceber | abnt: 'preco': 2 }}</td>
        </ng-container>

        <!-- Taxa e tarifa do intermediador previstas pelo pedido de venda (T07) -->
        <ng-container matColumnDef="taxaIntermediador">
          <th mat-header-cell *matHeaderCellDef>Taxa/tarifa interm. (prev.)</th>
          <td mat-cell *matCellDef="let row">{{ row.valorTaxaPrevisto ? (row.valorTaxaPrevisto | abnt: 'preco': 2) : '-' }}</td>
        </ng-container>

        <!-- Vencimento -->
        <ng-container matColumnDef="vencimento">
          <th mat-header-cell *matHeaderCellDef>Vencimento</th>
          <td mat-cell *matCellDef="let row">{{ row.vencimento | date: 'dd/MM/yyyy' }}</td>
        </ng-container>

        <!-- Tags -->
        <ng-container matColumnDef="tags">
          <th mat-header-cell *matHeaderCellDef>Tags</th>
          <td mat-cell *matCellDef="let row">
            <div class="tags-cell">
              @for (tag of row.tags; track tag.id) {
              <app-ui-tag [text]="tag.descricao" [bgColor]="tag.cor"></app-ui-tag>
              }
            </div>
          </td>
        </ng-container>

        <!-- Situação -->
        <ng-container matColumnDef="situacao">
          <th mat-header-cell *matHeaderCellDef>Situação</th>
          <td mat-cell *matCellDef="let row">
            <div class="tags-cell">
              <span class="status-badge" [ngClass]="getSituacaoClass(row.idStatus)">
                {{ row.situacao }}
              </span>
              @if (isVencido(row)) {
              <span class="status-badge badge-vermelho"
                matTooltip="Conta vencida em {{row.vencimento | date: 'dd/MM/yyyy'}}">Vencido</span>
              }
            </div>
          </td>
        </ng-container>

        <!-- Boleto -->
        <ng-container matColumnDef="boleto">
          <th mat-header-cell *matHeaderCellDef>Boleto</th>
          <td mat-cell *matCellDef="let row">
            @if (row.idStatusBoleto) {
            <div class="boleto-cell">
              <!-- Recusa de baixa: tag fica vermelha com o motivo, mesmo o boleto estando Registrado. -->
              <span class="status-badge"
                [ngClass]="row.motivoRecusaBaixa ? 'badge-vermelho' : getBoletoClass(row.idStatusBoleto)"
                [matTooltip]="row.motivoRecusaBaixa ? ('Baixa recusada: ' + row.motivoRecusaBaixa + ' — baixe manualmente no portal do banco.') : (row.motivoFalhaBoleto || '')"
                [matTooltipDisabled]="!row.motivoRecusaBaixa && !row.motivoFalhaBoleto">
                {{ row.statusBoletoDescricao }}
              </span>
              @if (row.motivoRecusaBaixa) {
              <span class="material-symbols-outlined boleto-recusa-icon"
                [matTooltip]="'Baixa recusada: ' + row.motivoRecusaBaixa + ' — baixe manualmente no portal do banco.'"
                (click)="$event.stopPropagation()">warning</span>
              }
            </div>
            } @else {
            <span class="text-muted">—</span>
            }
          </td>
        </ng-container>

        <!-- Ações -->
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef class="text-center">Ações</th>
          <td mat-cell *matCellDef="let row" class="text-center">
            <button mat-icon-button class="icon-mat-symbols-btn" [matMenuTriggerFor]="menuRow" aria-label="Ações"
              (click)="$event.stopPropagation()">
              <span class="material-symbols-outlined">more_horiz</span>
            </button>
            <mat-menu #menuRow="matMenu">
              <span class="menu-item-tooltip-wrapper" [matTooltip]="tooltipReceber(row)"
                [matTooltipDisabled]="!tooltipReceber(row)" [matTooltipPosition]="'above'">
                <button mat-menu-item (click)="abrirRecebimento([row])" [disabled]="
                    row.idStatus === _statusContasReceberEnum.Cancelada ||
                    row.idStatus === _statusContasReceberEnum.Recebido ||
                    row.idStatus === _statusContasReceberEnum.Perda ||
                    row.idStatus === _statusContasReceberEnum.PerdaParcial
                  ">
                  <span class="material-symbols-outlined">payments</span>
                  <span>Receber</span>
                </button>
              </span>
              <span class="menu-item-tooltip-wrapper" [matTooltip]="tooltipEstorno(row)"
                [matTooltipDisabled]="!tooltipEstorno(row)" [matTooltipPosition]="'above'">
                <button mat-menu-item (click)="estornarRecebimento(row)" [disabled]="
                    row.idStatus !== _statusContasReceberEnum.Recebido &&
                    row.idStatus !== _statusContasReceberEnum.RecebidoParcialmente
                  ">
                  <span class="material-symbols-outlined">undo</span>
                  <span>Estornar Recebimento</span>
                </button>
              </span>
              <span class="menu-item-tooltip-wrapper" [matTooltip]="tooltipPerda(row)"
                [matTooltipDisabled]="!tooltipPerda(row)" [matTooltipPosition]="'above'">
                <button mat-menu-item (click)="marcarComoPerda(row)" [disabled]="!isPerdavel(row)">
                  <span class="material-symbols-outlined">money_off</span>
                  <span>Marcar como perda</span>
                </button>
              </span>
              <span class="menu-item-tooltip-wrapper" [matTooltip]="tooltipReverterPerda(row)"
                [matTooltipDisabled]="!tooltipReverterPerda(row)" [matTooltipPosition]="'above'">
                <button mat-menu-item (click)="reverterPerda(row)" [disabled]="!isReversivelPerda(row)">
                  <span class="material-symbols-outlined">settings_backup_restore</span>
                  <span>Reverter perda</span>
                </button>
              </span>
              <span class="menu-item-tooltip-wrapper" [matTooltip]="isOrigemDocumento(row) ? tooltipOrigemDocumento(row) : tooltipEditar(row)"
                [matTooltipDisabled]="isEditavelPeloFinancas(row)" [matTooltipPosition]="'above'">
                <button mat-menu-item (click)="alterarFormaRecebimento([row])" [disabled]="!isEditavelPeloFinancas(row)">
                  <span class="material-symbols-outlined">swap_horiz</span>
                  <span>Alterar forma de recebimento</span>
                </button>
              </span>
              <button mat-menu-item (click)="alterarTagsEmMassa([row])">
                <span class="material-symbols-outlined">label</span>
                <span>Alterar tags</span>
              </button>
              <span class="menu-item-tooltip-wrapper" [matTooltip]="tooltipEditar(row)"
                [matTooltipDisabled]="isEditavel(row)" [matTooltipPosition]="'above'">
                <button mat-menu-item (click)="alterarCategoriaEmMassa([row])" [disabled]="!isEditavel(row)">
                  <span class="material-symbols-outlined">category</span>
                  <span>Alterar categoria</span>
                </button>
              </span>
              @if (row.isParcelado) {
              <span class="menu-item-tooltip-wrapper" [matTooltip]="isOrigemDocumento(row) ? tooltipOrigemDocumento(row) : tooltipEditar(row)"
                [matTooltipDisabled]="isEditavelPeloFinancas(row)" [matTooltipPosition]="'above'">
                <button mat-menu-item [routerLink]="['/financas/contas-receber/parcela', row.idContasReceberParcela]"
                  [disabled]="!isEditavelPeloFinancas(row)">
                  <span class="material-symbols-outlined">edit</span>
                  <span>Editar Parcela</span>
                </button>
              </span>
              }
              <span class="menu-item-tooltip-wrapper" [matTooltip]="isOrigemDocumento(row) ? tooltipOrigemDocumento(row) : tooltipEditar(row)"
                [matTooltipDisabled]="isEditavelPeloFinancas(row) || row.isAgrupado" [matTooltipPosition]="'above'">
                <button mat-menu-item [routerLink]="[
                    '/financas/contas-receber/cadastrar',
                    { idContasReceber: row.idContasReceber },
                  ]" [disabled]="!isEditavelPeloFinancas(row) && !row.isAgrupado">
                  <span class="material-symbols-outlined">edit</span>
                  <span>Editar Lançamento</span>
                </button>
              </span>
              @if (row.isAgrupado) {
              <span class="menu-item-tooltip-wrapper" [matTooltip]="tooltipDesagrupar(row)"
                [matTooltipDisabled]="isDesagrupavel(row)" [matTooltipPosition]="'above'">
                <button mat-menu-item (click)="desagrupar(row)" [disabled]="!isDesagrupavel(row)">
                  <span class="material-symbols-outlined">call_split</span>
                  <span>Desagrupar</span>
                </button>
              </span>
              }
              <span class="menu-item-tooltip-wrapper" [matTooltip]="tooltipCancelar(row)"
                [matTooltipDisabled]="isCancelavel(row)" [matTooltipPosition]="'above'">
                <button mat-menu-item (click)="cancelarContas([row])" [disabled]="!isCancelavel(row)">
                  <span class="material-symbols-outlined">cancel</span>
                  <span>Cancelar</span>
                </button>
              </span>
              <span class="menu-item-tooltip-wrapper" [matTooltip]="tooltipExcluir(row)"
                [matTooltipDisabled]="isExcluivel(row)" [matTooltipPosition]="'above'">
                <button mat-menu-item (click)="excluirContas([row])" [disabled]="!isExcluivel(row)">
                  <span class="material-symbols-outlined">delete</span>
                  <span>Excluir</span>
                </button>
              </span>
              @if (row.idStatus === _statusContasReceberEnum.EmAberto) {
              <button mat-menu-item (click)="gerarCobranca(row)"
                [disabled]="gerandoCobrancaMap.get(row.idContasReceberParcela)">
                <span class="material-symbols-outlined">send</span>
                <span>{{ gerandoCobrancaMap.get(row.idContasReceberParcela) ? 'Enviando...' : 'Gerar Cobrança' }}</span>
              </button>
              }
              @if (isBoletoBaixavel(row)) {
              <button mat-menu-item (click)="baixarBoletos([row])">
                <span class="material-symbols-outlined">receipt_long</span>
                <span>Baixar boleto</span>
              </button>
              }
              @if (row.urlBoletoPdf) {
              <a mat-menu-item [href]="row.urlBoletoPdf" target="_blank" rel="noopener">
                <span class="material-symbols-outlined">picture_as_pdf</span>
                <span>Download do Boleto</span>
              </a>
              }
            </mat-menu>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </div>

    <!-- Mobile View -->
    <div class="mobile-view">
      @for (item of _dataSource.data; track item.idContasReceberParcela) {
      <div class="card-mobile mb-3" [class.selected-card]="selection.isSelected(item)">
        <div class="card-header-mobile d-flex justify-content-between align-items-center">
          <div class="d-flex align-items-center gap-2">
            <mat-checkbox (change)="$event ? selection.toggle(item) : null" [checked]="selection.isSelected(item)"
              color="primary">
            </mat-checkbox>
            <div class="d-flex flex-column">
              <span class="text-bold">{{ item.cliente || '-' }}</span>
              <small>{{ item.descricao }}</small>
            </div>
          </div>
          <button mat-icon-button class="icon-mat-symbols-btn" [matMenuTriggerFor]="menuMobile">
            <span class="material-symbols-outlined">more_horiz</span>
          </button>
          <mat-menu #menuMobile="matMenu">
            <button mat-menu-item (click)="abrirRecebimento([item])">Receber</button>
            <span class="menu-item-tooltip-wrapper" [matTooltipPosition]="'above'" [matTooltip]="
                    item.idStatus !== _statusContasReceberEnum.Recebido &&
                    item.idStatus !== _statusContasReceberEnum.RecebidoParcialmente
                      ? 'Apenas parcelas com Recebimento completo ou parcial podem ser estornadas'
                      : ''
                  ">
              <button mat-menu-item (click)="estornarRecebimento(item)" [disabled]="
                      item.idStatus !== _statusContasReceberEnum.Recebido &&
                      item.idStatus !== _statusContasReceberEnum.RecebidoParcialmente
                    ">
                Estornar Recebimento
              </button>
            </span>
            <span class="menu-item-tooltip-wrapper" [matTooltipPosition]="'above'" [matTooltip]="tooltipPerda(item)"
              [matTooltipDisabled]="!tooltipPerda(item)">
              <button mat-menu-item (click)="marcarComoPerda(item)" [disabled]="!isPerdavel(item)">
                Marcar como perda
              </button>
            </span>
            <span class="menu-item-tooltip-wrapper" [matTooltipPosition]="'above'"
              [matTooltip]="tooltipReverterPerda(item)" [matTooltipDisabled]="!tooltipReverterPerda(item)">
              <button mat-menu-item (click)="reverterPerda(item)" [disabled]="!isReversivelPerda(item)">
                Reverter perda
              </button>
            </span>
            <button mat-menu-item (click)="alterarTagsEmMassa([item])">Alterar tags</button>
            <button mat-menu-item (click)="alterarCategoriaEmMassa([item])">Alterar categoria</button>
            @if (item.isParcelado) {
            <button mat-menu-item [routerLink]="['/financas/contas-receber/parcela', item.idContasReceberParcela]">
              Editar Parcela
            </button>
            }
            <button mat-menu-item [routerLink]="[
                    '/financas/contas-receber/cadastrar',
                    { idContasReceber: item.idContasReceber },
                  ]">
              Editar Lançamento
            </button>
            @if (item.isAgrupado) {
            <span class="menu-item-tooltip-wrapper" [matTooltipPosition]="'above'"
              [matTooltip]="tooltipDesagrupar(item)" [matTooltipDisabled]="isDesagrupavel(item)">
              <button mat-menu-item (click)="desagrupar(item)" [disabled]="!isDesagrupavel(item)">
                Desagrupar
              </button>
            </span>
            }
            <span class="menu-item-tooltip-wrapper" [matTooltipPosition]="'above'" [matTooltip]="
                    item.idStatus !== _statusContasReceberEnum.EmAberto
                      ? 'A conta precisa estar Em Aberto'
                      : ''
                  ">
              <button mat-menu-item (click)="cancelarContas([item])"
                [disabled]="item.idStatus !== _statusContasReceberEnum.EmAberto">
                Cancelar
              </button>
            </span>
            <span class="menu-item-tooltip-wrapper" [matTooltipPosition]="'above'" [matTooltip]="
                    item.idStatus !== _statusContasReceberEnum.EmAberto &&
                    item.idStatus !== _statusContasReceberEnum.Cancelada
                      ? 'A conta precisa estar Em Aberto ou Cancelada'
                      : ''
                  ">
              <button mat-menu-item (click)="excluirContas([item])" [disabled]="
                      item.idStatus !== _statusContasReceberEnum.EmAberto &&
                      item.idStatus !== _statusContasReceberEnum.Cancelada
                    ">
                Excluir
              </button>
            </span>
            @if (item.idStatus === _statusContasReceberEnum.EmAberto) {
            <button mat-menu-item (click)="gerarCobranca(item)"
              [disabled]="gerandoCobrancaMap.get(item.idContasReceberParcela)">
              {{ gerandoCobrancaMap.get(item.idContasReceberParcela) ? 'Enviando...' : 'Gerar Cobrança' }}
            </button>
            }
          </mat-menu>
        </div>
        <div class="card-body-mobile p-3">
          <div class="row">
            <div class="col-6 mb-2">
              <small class="d-block">Valor</small>
              <span class="text-bold">{{ item.valor | abnt: 'preco': 2 }}</span>
            </div>
            <div class="col-6 mb-2">
              <small class="d-block">A Receber</small>
              <span>{{ item.aReceber | abnt: 'preco': 2 }}</span>
            </div>
            <div class="col-12 mb-2">
              <small class="d-block">Vencimento</small>
              <span>{{ item.vencimento | date: 'dd/MM/yyyy' }}</span>
            </div>
            <div class="col-12 mb-2">
              <small class="d-block">Situação</small>
              <div class="tags-cell">
                <span class="status-badge" [ngClass]="getSituacaoClass(item.idStatus)">
                  {{ item.situacao }}
                </span>
                @if (isVencido(item)) {
                <span class="status-badge badge-vermelho"
                  matTooltip="Conta vencida em {{item.vencimento | date: 'dd/MM/yyyy'}}">
                  Vencido
                </span>
                }
              </div>
            </div>
            @if (item.tags?.length) {
            <div class="col-12 mb-2">
              <small class="d-block">Tags</small>
              <div class="tags-cell">
                @for (tag of item.tags; track tag.id) {
                <app-ui-tag [text]="tag.descricao" [bgColor]="tag.cor"></app-ui-tag>
                }
              </div>
            </div>
            }
          </div>
        </div>
      </div>
      }
    </div>

    <!-- Ver Mais -->
    <div class="col-12 text-center">
      <button mat-button [disabled]="_ultimaPagina" (click)="proximaPagina()">
        @if (_isLoading === true) {
        <mat-spinner [diameter]="20"></mat-spinner>
        } @else {
        <span class="material-symbols-outlined">expand_more</span>
        Ver Mais
        }
      </button>
    </div>
    } @else if (_isLoading === true && _dataSource.data.length === 0) {
    <app-loading-box-default-list></app-loading-box-default-list>
    } @else {
    <app-empty-list [title]="'Nenhum lançamento encontrado'"
      [subTitle]="'Tente alterar os filtros de busca'"></app-empty-list>
    }
  </div>
</div>

<div class="footer-totals">
<div class="footer-totals-inner">
  <div class="footer-totals-item footer-totals-item--saida">
    <span class="footer-totals-label">Vencidos (R$)</span>
    @if (_ocultarValores) {
    <span class="footer-totals-value">••••</span>
    } @else {
    <span class="footer-totals-value">{{ _totalVencidos | abnt: 'preco': 2 }}</span>
    }
  </div>
  <div class="footer-totals-item footer-totals-item--alerta">
    <span class="footer-totals-label">Vencem hoje (R$)</span>
    @if (_ocultarValores) {
    <span class="footer-totals-value">••••</span>
    } @else {
    <span class="footer-totals-value">{{ _totalVencemHoje | abnt: 'preco': 2 }}</span>
    }
  </div>
  <div class="footer-totals-item footer-totals-item--info">
    <span class="footer-totals-label">A vencer (R$)</span>
    @if (_ocultarValores) {
    <span class="footer-totals-value">••••</span>
    } @else {
    <span class="footer-totals-value">{{ _totalAVencer | abnt: 'preco': 2 }}</span>
    }
  </div>
  <div class="footer-totals-item footer-totals-item--entrada">
    <span class="footer-totals-label">Recebidos (R$)</span>
    @if (_ocultarValores) {
    <span class="footer-totals-value">••••</span>
    } @else {
    <span class="footer-totals-value">{{ _totalRecebidos | abnt: 'preco': 2 }}</span>
    }
  </div>
  <div class="footer-totals-item footer-totals-item--total">
    <span class="footer-totals-label">Total do período (R$)</span>
    @if (_ocultarValores) {
    <span class="footer-totals-value">••••</span>
    } @else {
    <span class="footer-totals-value">{{ _totalPeriodo | abnt: 'preco': 2 }}</span>
    }
  </div>
  <div class="footer-totals-count">
    <mat-icon class="material-symbols-outlined">description</mat-icon>
    <span>{{ _quantidadeLancamentos }} Lançamentos</span>
  </div>
  <button mat-icon-button class="icon-mat-symbols-btn" (click)="toggleOcultarValores()"
    matTooltip="Ocultar/Exibir valores">
    <mat-icon class="material-symbols-outlined">{{
      _ocultarValores ? 'visibility_off' : 'visibility'
      }}</mat-icon>
  </button>
</div>
</div>
<div class="footer-totals-height-fake"></div>

<!-- Mobile FAB -->
<button type="button" class="btn-footer-totals-mobile" (click)="toggleGavetaMobile()" aria-label="Abrir resumo financeiro">
  <span class="material-symbols-outlined">analytics</span>
</button>

<!-- Mobile Drawer Backdrop -->
@if (isMobileDrawerOpen) {
<div class="footer-totals-mobile-sheet-backdrop" (click)="fecharGavetaMobile()"></div>
}

<!-- Mobile Drawer -->
<div class="footer-totals-mobile-sheet" [class.open]="isMobileDrawerOpen">
  <div class="footer-totals-mobile-sheet__header modal-header">
    <div class="modal-header-icon">
      <mat-icon class="material-symbols-outlined">analytics</mat-icon>
    </div>
    <div class="modal-header-titles">
      <h3 class="modal-title">Resumo Financeiro</h3>
    </div>
    <div class="modal-header-close-btn-container">
      <button mat-icon-button type="button" class="modal-close-btn icon-mat-symbols-btn" (click)="fecharGavetaMobile()" aria-label="Fechar resumo financeiro">
        <mat-icon class="material-symbols-outlined">close</mat-icon>
      </button>
    </div>
  </div>
  <div class="footer-totals-mobile-sheet__content">
    <div class="footer-totals-mobile-sheet__item footer-totals-mobile-sheet__item--saida">
      <span class="footer-totals-mobile-sheet__label">VENCIDOS (R$)</span>
      <span class="footer-totals-mobile-sheet__value">{{ _ocultarValores ? '••••' : (_totalVencidos | abnt: 'preco': 2)
        }}</span>
    </div>
    <div class="footer-totals-mobile-sheet__item footer-totals-mobile-sheet__item--alerta">
      <span class="footer-totals-mobile-sheet__label">VENCEM HOJE (R$)</span>
      <span class="footer-totals-mobile-sheet__value">{{ _ocultarValores ? '••••' : (_totalVencemHoje | abnt: 'preco': 2) }}</span>
    </div>
    <div class="footer-totals-mobile-sheet__item footer-totals-mobile-sheet__item--info">
      <span class="footer-totals-mobile-sheet__label">A VENCER (R$)</span>
      <span class="footer-totals-mobile-sheet__value">{{ _ocultarValores ? '••••' : (_totalAVencer | abnt: 'preco': 2) }}</span>
    </div>
    <div class="footer-totals-mobile-sheet__item footer-totals-mobile-sheet__item--entrada">
      <span class="footer-totals-mobile-sheet__label">RECEBIDOS (R$)</span>
      <span class="footer-totals-mobile-sheet__value">{{ _ocultarValores ? '••••' : (_totalRecebidos | abnt: 'preco': 2)
        }}</span>
    </div>
    <div class="footer-totals-mobile-sheet__item footer-totals-mobile-sheet__item--total footer-totals-mobile-sheet__item--full">
      <span class="footer-totals-mobile-sheet__label">TOTAL DO PERÍODO (R$)</span>
      <span class="footer-totals-mobile-sheet__value footer-totals-mobile-sheet__total footer-totals-mobile-sheet__total--large">{{ _ocultarValores ? '••••' : (_totalPeriodo | abnt:
        'preco': 2) }}</span>
    </div>
  </div>
  <div class="footer-totals-mobile-sheet__footer">
    <span class="footer-totals-count">
      <mat-icon class="material-symbols-outlined">description</mat-icon>
      {{ _quantidadeLancamentos }} Lançamentos
    </span>
    <button mat-icon-button type="button" class="icon-mat-symbols-btn" (click)="toggleOcultarValores()"
      [matTooltip]="_ocultarValores ? 'Exibir valores' : 'Ocultar valores'"
      [attr.aria-label]="_ocultarValores ? 'Exibir valores' : 'Ocultar valores'">
      <mat-icon class="material-symbols-outlined">{{ _ocultarValores ? 'visibility_off' : 'visibility' }}</mat-icon>
    </button>
  </div>
</div>
